import type { ChatUiBusStopOption } from '@voll-intelligence/genui-contract';
import { useGenUiI18n } from '../../../shared/ui/i18n.js';
import { CardFooter } from '../../../shared/ui/card.js';
import './bus_stops.css';

/**
 * Seletor de rodoviária (`bus_stops`) — desambiguação de parada por TOQUE, no
 * lugar da lista numerada em texto. Card compacto: título localizado por `which`
 * (origem/destino) + uma linha tocável por candidata. O toque vira quick-reply
 * com o NOME EXATO da opção (`onPick`) — o agents casa por nome (exact-match)
 * contra as candidatas pendentes server-side; nenhum código viaja no wire.
 * `readOnly` (card congelado de turno anterior) desabilita os botões.
 */
export function BusStopsPicker({
  which,
  options,
  note,
  readOnly = false,
  onPick,
}: {
  readonly which: 'origin' | 'destination';
  readonly options: ChatUiBusStopOption[];
  readonly note?: string;
  readonly readOnly?: boolean;
  readonly onPick: (name: string) => void;
}) {
  const { t } = useGenUiI18n();
  return (
    <div className="bst" aria-label={t('busStops.aria')}>
      <h4 className="bst-ttl">
        {t(which === 'origin' ? 'busStops.titleOrigin' : 'busStops.titleDestination')}
      </h4>
      <ul className="bst-list">
        {options.map((o) => (
          <li key={o.name}>
            <button
              type="button"
              className="bst-opt"
              disabled={readOnly}
              onClick={() => {
                onPick(o.name);
              }}
            >
              {o.name}
            </button>
          </li>
        ))}
      </ul>
      <CardFooter note={note} />
    </div>
  );
}
